
    import {defineComponent, reactive} from 'vue'
    import {useRoute} from "vue-router";

    interface State {
        channelType: string;
        reportLevel: number;
    }
    export default defineComponent({
        name: "ensureServiceExplain",
        setup() {
            let state: State = reactive({
                channelType: '',
                reportLevel: 0,
            })
            const {query} = useRoute();
            state.channelType = `${query.channelType}` || '';
            state.reportLevel = Number(`${query.reportLevel}`) || 0;
            return {
                state
            }
        },
        methods: {
            goBack(){
                history.go(-1)
            }
        }
    })
